import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../features/auth/store';
import { resolveNavRoute } from '../shared/utils/navRoutes';
import type { PageType } from '../shared/utils/navRoutes';
import { getDefaultRouteForRole } from '../features/auth/permissions';

export default function NavPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();

  useEffect(() => {
    const type = searchParams.get('type') as PageType | null;
    const id = searchParams.get('id') ?? undefined;
    const action = searchParams.get('action') ?? undefined;

    if (!type) {
      navigate(getDefaultRouteForRole(user?.roleName), { replace: true });
      return;
    }

    const destination = resolveNavRoute({ type, id, action });

    if (!destination) {
      navigate(getDefaultRouteForRole(user?.roleName), { replace: true });
      return;
    }

    if (!isAuthenticated) {
      const encoded = encodeURIComponent(window.location.pathname + window.location.search);
      navigate(`/login?redirect_to=${encoded}`, { replace: true });
      return;
    }

    navigate(destination, { replace: true });
  }, [searchParams, navigate, isAuthenticated, user?.roleName]);

  return null;
}
